import "./Page.css"

import { Navigate, useLocation } from "react-router"
import { toast } from "react-toastify"

import PageTitle from "@/components/PageTitle/PageTitle"
import { useProfileData, useSurveysData } from "@/queries/queries"
import { checkProfileComplete } from "@/utils/helpers"

function useIsProfileComplete() {
  const profileData = useProfileData()
  return profileData?.isLoading ? true : checkProfileComplete(profileData?.data)
}

function useHasSurveys() {
  const surveyData = useSurveysData()

  const hasPendingSurveys =
    surveyData.isLoading || surveyData.data?.data?.length === 0
      ? false
      : surveyData.data?.data?.some((survey) => !survey.user_answers)

  const pendingSurvey = hasPendingSurveys
    ? surveyData.data?.data?.find((survey) => !survey.user_answers)
    : null

  return { hasPendingSurveys, pendingSurvey }
}

interface PageProps {
  title: string
  children: React.ReactNode
}

export default function Page({ title, children }: PageProps) {
  const location = useLocation()
  const isProfileRoute = location.pathname.startsWith("/profile")
  const isSurveysRoute = location.pathname.startsWith("/surveys")

  const isProfileComplete = useIsProfileComplete()
  const { hasPendingSurveys, pendingSurvey } = useHasSurveys()

  const content = (
    <>
      <PageTitle title={title} />
      {/* <div className="ramadan-page-decoration" /> */}
      <div className="page-content">{children}</div>
    </>
  )

  // if profile not complete
  if (!isProfileComplete && !isProfileRoute) {
    toast.info(() => {
      return (
        <div>
          {/* eslint-disable-next-line i18next/no-literal-string */}
          <p dir="ltr">Please complete your profile first</p>
          {/* eslint-disable-next-line i18next/no-literal-string */}
          <p dir="rtl">برجاء اكمال ملفك الشخصي</p>
        </div>
      )
    })
    return <Navigate to="/profile" />
  }
  // if survey not done
  else if (hasPendingSurveys && !isSurveysRoute) {
    toast.info(() => {
      return (
        <div>
          {/* eslint-disable-next-line i18next/no-literal-string */}
          <p dir="ltr">Please complete this survey first</p>
          {/* eslint-disable-next-line i18next/no-literal-string */}
          <p dir="rtl">برجاء اكمال هذا الاستبيان اولا</p>
        </div>
      )
    })
    return <Navigate to={`/surveys/answer/${pendingSurvey?.slug}`} />
  } else {
    return content
  }
}
